module.exports = __webpack_public_path__ + "media/award_1.0bddc99e.mp3";